import RevenueSales from './revenueSales'
import ClaimsSummary from './claimsSummary'
import ClaimsNotifications from './claimsNotifications'

const state = Object.assign({}, RevenueSales.state, ClaimsSummary.state, ClaimsNotifications.state)
const getters = Object.assign({}, RevenueSales.getters, ClaimsSummary.getters, ClaimsNotifications.getters)
const actions = Object.assign({}, RevenueSales.actions, ClaimsSummary.actions, ClaimsNotifications.actions)
const mutations = Object.assign({}, RevenueSales.mutations, ClaimsSummary.mutations, ClaimsNotifications.mutations)

export default {
  state,
  getters,
  mutations,
  actions
}
